module.exports = __webpack_public_path__ + "media/images/v2/icon4-514a8598a243273b232984ef7ada87bc.png";